export function fatalError(err) {
    setTimeout(() => { throw err; }, 0);
}
//# sourceMappingURL=fatalError.js.map